/*
 * True while the window is phone width, and it follows a turn of the phone or a resized window. The phone screens
 * (Schedule's day board, Home's swipe cards) are drawn from it; everything else stays in the CSS.
 */
import { useEffect, useState } from "react";

export const PHONE = "(max-width: 640px)";

export function usePhone(query = PHONE): boolean {
  const [on, setOn] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const m = window.matchMedia(query);
    const change = () => setOn(m.matches);
    change();
    m.addEventListener("change", change);
    return () => m.removeEventListener("change", change);
  }, [query]);
  return on;
}
